import clsx from "clsx"
import { useCallback, useContext, useEffect, useState } from "react"
import { MediaMobile, MediaTablet } from "../../../../api/const/MediaQuery"
import useMediaQuery from "../../../../hook/useMediaQuery"
import { AppGeneralContext } from "../../../../shared/GeneralContext/GeneralContext"
import { fromGetDayToWeekDay, fromGetMonthToMonthName } from "../../../../shared/utils/formatFunction"
import { Button } from "../../../atoms"
import { DatesCard } from "./DatesCard"
import { postCheckEmailAvailability, postCitiesList, postCompanySendDates, postCompanyStartMatch, postRegisterCompanyGuest } from "api/Api"
import { CompanyGuestStartMatchReq, CompanySendDatesReq, CompanyStartMatchReq, GuestUser, GuestUserReq } from "components/types/Api"
import { CorporateGuest, Modal, ModalType, OptionTypes, StartUp, initialCorporateGuest } from "components/types/types"
import { useLocation, useParams } from "react-router-dom"
import { MatchStatus } from "components/types/Context"
import { useAuth } from "shared/auth"
import * as Yup from "yup";
import { useFormik } from "formik"
import Select from 'react-select';
import { customStyles } from "shared/style"
import { StatusCode } from "api/const"
import axios from "axios"
import { useGuestView } from "shared/GeneralContext/GuestContext"
import { emailRegex } from "shared/const"

enum ResumeStatus {
  startupAskAMatch = 1,
  companyAskAMatch = 2,
  companySendNewDate = 3
}

const corporateSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(3, 'Too Short!, min 3 char')
    .max(70, 'Too Long!, max 70 char')
    .required('Please complete this required field.'),
  lastName: Yup.string()
    .min(3, 'Too Short!, min 3 char')
    .max(70, 'Too Long!, max 70 char')
    .required('Please complete this required field.'),
  email: Yup.string()
    .matches(emailRegex, 'Wrong email format')
    .required('Please complete this required field.'),
  companyName: Yup.string()
    .min(3, 'Too Short!, min 3 char')
    .max(70, 'Too Long!, max 70 char')
    .required('Please complete this required field.'),
  city: Yup.object().shape({
    value: Yup.string()
      .required('Please complete this required field.'),
  }),
});

export const Resume = (props: any) => {
  const { setDateResponse, setErrorModal, setModal,
    matchCallDates, resetMatchCallDates, getMatchList, setChatIsOpen,
    chatIsOpen, matchSelected, messagesList, startUpIdforMatch,
    getStartupsList, setModalDatesIsOpen, setstartUpIdforMatch,
    getStartupById, startUpById, IsLoadingGetStartupbyId, setReqStartup, startupsList,
    setStartupsList } = useContext(AppGeneralContext)
  const mobile = useMediaQuery(MediaMobile)
  const tablet = useMediaQuery(MediaTablet)
  const location = useLocation()
  const [status, setStatus] = useState<ResumeStatus>()
  const { auth } = useAuth()
  const [corporateGuest] = useState<CorporateGuest>({
    ...initialCorporateGuest
  })
  const [activeConfirm, setActiveConfirm] = useState<boolean>(false)
  const [cities, setCities] = useState<OptionTypes[]>()
  const [city, setCity] = useState<string>("")
  const { updateGuestUser } = useGuestView()
  const { startupId } = useParams()

  useEffect(() => {
    if (startupId) {
      setstartUpIdforMatch(startupId)
    }
  }, [])

  useEffect(() => {
    if (city.length >= 3) {
      postCitiesList({ data: city }).then((res) => {

        if (!res.isSuccess || !res.response) {
          setErrorModal(res.error)
          return false
        }

        const response = res.response.data
        setCities(response)
      })
    } else {
      setCities([])
    }

  }, [city.length])

  useEffect(() => {
    postCitiesList({ data: city }).then((res) => {

      if (!res.isSuccess || !res.response) {
        setErrorModal(res.error)
        return false
      }

      const response = res.response.data
      setCities(response)
    })


  }, [])

  const change = () => {
    resetMatchCallDates()
    props.goToStep(1)
  }

  const formik = useFormik<CorporateGuest>({
    initialValues: corporateGuest,
    validationSchema: corporateSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)

      const registerRequest = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        companyName: values.companyName,
        city: values.city.value
      }

      setDateResponse({ type: 1, title: "loading", message: "Loading data, please wait" });
      const reqGuestMatch: CompanyGuestStartMatchReq = {
        firstDateAvailable: matchCallDates?.[0].date as string,
        secondDateAvailable: matchCallDates?.[1].date as string,
        thirdDateAvailable: matchCallDates?.[2].date as string,
        startupId: startUpIdforMatch,
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        companyName: values.companyName,
        cityId: values.city.value
      }


      CompanyStartAMatch(reqGuestMatch)

      props.nextStep()

      setSubmitting(false)

      //   if (!registerCompanyResponse.isSuccess || !registerCompanyResponse.response) {
      //     setErrorModal(registerCompanyResponse.error)
      //     return
      //   }

    }
  })




  useEffect(() => {
    if (!formik.errors.email &&
      !!formik.touched.email &&
      isNotEmpty(formik.values.email) &&
      formik.values.email.includes("@") &&
      formik.values.email.includes(".")) {
      let req = { email: formik.values.email, isStartup: false }
      postCheckEmailAvailability(req).then((res) => {

        if (!res.isSuccess || !res.response) {
          setErrorModal(res.error)
          return false
        }

        if (!res.response.isAvailable) {
          if (res.response.isCompany) {
            setErrorModal(`${StatusCode.EMAIL_NOT_AVAIABLE}`)
            formik.setFieldError("email", "Email already used");
            let user = res.response.existingGuestUser
            let guestUser: GuestUser = {
              firstName: user ? user.firstName : "",
              lastName: user ? user.lastName : "",
              email: formik.values.email,
              featuredStartupID: startUpIdforMatch,
              date1: matchCallDates?.[0].date as string,
              date2: matchCallDates?.[1].date as string,
              date3: matchCallDates?.[2].date as string,
              city: user ? user.city : { value: "", label: "" },
              companyName: user ? user.companyName : ""
            }
            updateGuestUser(guestUser)
          } else {
            let error: Modal = {
              isOpen: true,
              type: "error",
              title: "Please Wait",
              message: "You cannot request the match with the email entered, enter a different one and try again"
            }
            setModal(error)
            formik.setFieldError("email", "Email already used");
            return
          }
        }

        if (!!res.response.existingGuestUser) {
          let user = res.response.existingGuestUser
          formik.setFieldValue("firstName", user.firstName);
          formik.setFieldValue("lastName", user.lastName);
          formik.setFieldValue("companyName", user.companyName);
          formik.setFieldValue("city", user.city);
          formik.setFieldValue("email", user.email);
          formik.setFieldTouched("firstName", true);
          formik.setFieldTouched("lastName", true);
          formik.setFieldTouched("companyName", true);
          formik.setFieldTouched("city", true);
          formik.setFieldTouched("email", true);
        }
      })

    }
  }, [formik.errors.email, formik.touched.email, formik.values.email])



  useEffect(() => {
    if (messagesList.length > 0) {
      messagesList.map((x, i, arr) => {

        if (arr[arr.length - 1].status === MatchStatus.StartupAskedNewAvailability) {
          return setStatus(ResumeStatus.companySendNewDate)
        } else {
          if (arr[0].status === MatchStatus.StartupStartedMatch) {
            return setStatus(ResumeStatus.startupAskAMatch)
          } else {
            return setStatus(ResumeStatus.companyAskAMatch)
          }
        }
      })
    } else {
      return setStatus(ResumeStatus.companyAskAMatch)
    }
  }, [messagesList])

  const CompanySendDates = useCallback((req: CompanySendDatesReq) => {
    postCompanySendDates(req).then((res) => {
      if (!res.isSuccess || !res.response) {
        setDateResponse({ type: -1, title: "ERROR", message: res.error ?? "Something went wrong" })
        return
      }


      if (location.pathname.toLowerCase().includes("/corporate/profile")) {
        let logged = auth?.jwtToken ? true : false
        getStartupsList(logged)
      } else {
        getStartupById(startUpIdforMatch)
      }
      setModalDatesIsOpen(false)
      setstartUpIdforMatch("")

      setDateResponse({ type: 2, title: "Match", message: "Your match request has been sent!" })
      if (chatIsOpen) {
        setChatIsOpen(false)
      }
      getMatchList()
    })
  }, [auth])


  const CompanyStartAMatch = useCallback((req: CompanyStartMatchReq, isGuest?: boolean) => {
    postCompanyStartMatch(req).then((res) => {

      if (!res.isSuccess || !res.response) {
        setDateResponse({ type: -1, title: "ERROR", message: res.error ?? "Something went wrong" })
        return
      }

      if (isGuest) {
        setDateResponse({ type: 2, title: "Match", message: "Your match request has been sent!" })
        return
      }

      if (location.pathname.toLowerCase().includes("/corporate/profile")) {

        const updatedList = startupsList.map((s: StartUp) => {
          if (s.id === req.startupId) {
            return { ...s, canMatch: false } as StartUp
          }
          return s
        })

        setStartupsList(updatedList)
        // setReqStartup(initialReqStartup)
        // getStartupsList()
      }
      setstartUpIdforMatch("")

      setDateResponse({ type: 2, title: "Match", message: "Your match request has been sent!" })
      if (chatIsOpen) {
        setChatIsOpen(false)
      }
      getMatchList()
    })
  }, [startupsList, startUpIdforMatch])




  const confirm = useCallback(
    () => {
      setDateResponse({ type: 1, title: "loading", message: "Loading data, please wait" });
      if (auth?.jwtToken) {
        const reqFirstMatch: CompanyStartMatchReq = {
          firstDateAvailable: matchCallDates?.[0].date as string,
          secondDateAvailable: matchCallDates?.[1].date as string,
          thirdDateAvailable: matchCallDates?.[2].date as string,
          startupId: startUpIdforMatch
        }

        const reqNewAvailability: CompanySendDatesReq = {
          firstDateAvailable: matchCallDates?.[0].date as string,
          secondDateAvailable: matchCallDates?.[1].date as string,
          thirdDateAvailable: matchCallDates?.[2].date as string,
          matchId: matchSelected?.id ? matchSelected.id : ""
        }

        props.nextStep()
        if (status === ResumeStatus.companyAskAMatch) {
          return CompanyStartAMatch(reqFirstMatch)
        }
        if (status === ResumeStatus.startupAskAMatch) {
          return CompanySendDates(reqNewAvailability)
        }
        if (status === ResumeStatus.companySendNewDate) {
          return CompanySendDates(reqNewAvailability)
        }



      } else {
        let req: GuestUserReq = {
          email: formik.values.email,
          city: formik.values.city.value,
          firstName: formik.values.firstName,
          lastName: formik.values.lastName,
          name: formik.values.companyName
        }

        postRegisterCompanyGuest(req).then((res) => {

          if (!res.isSuccess || !res.response) {
            setErrorModal(res.error)
            return false
          }


          axios.defaults.headers.common['Authorization'] = "Bearer " + res.response?.jwtToken;

          const reqFirstMatch: CompanyStartMatchReq = {
            firstDateAvailable: matchCallDates?.[0].date as string,
            secondDateAvailable: matchCallDates?.[1].date as string,
            thirdDateAvailable: matchCallDates?.[2].date as string,
            startupId: startUpIdforMatch
          }

          if (status === ResumeStatus.companyAskAMatch) {
            props.nextStep();
            return CompanyStartAMatch(reqFirstMatch, true)
          }

        })
      }


    },
    [auth?.jwtToken, startUpIdforMatch, JSON.stringify(matchCallDates), messagesList, status, props, formik.values, formik.values.city.value],
  )

  function isNotEmpty(par: string | undefined | null) {
    if (par === "" || par === undefined || par === null) {
      return false
    }
    return true
  }

  useEffect(() => {
    if (
      isNotEmpty(formik.values.firstName)
      && isNotEmpty(formik.values.lastName)
      && isNotEmpty(formik.values.companyName)
      && isNotEmpty(formik.values.email)
      && isNotEmpty(formik.values.city.value)
      && !formik.errors.email && !formik.errors.firstName && !formik.errors.lastName
      && !formik.errors.companyName && !formik.errors.city
    ) {
      setActiveConfirm(true)
    } else {
      setActiveConfirm(false)
    }

  }, [formik.values.firstName, formik.values.lastName, formik.values.companyName,
  formik.values.email, formik.values.city.value,
  formik.errors.email, formik.errors.firstName, formik.errors.lastName,
  formik.errors.companyName, formik.errors.city
  ])

  return (
    <div className="h-100 no-overflow  pb-5">
      <div className="pt-5 pb-3">
        <h4 className={clsx("p-0 m-0", { "text-center": mobile })}>Resume</h4>
      </div>
      <div className={clsx("d-flex  h-100 align-items-center pb-4", { "justify-content-center ": mobile })}>
        {matchCallDates && matchCallDates.length === 3 &&
          matchCallDates.map(x => {
            var newDate = new Date(x.date)
            return <DatesCard
              key={x.id}
              dayName={fromGetDayToWeekDay(newDate.getDay())}
              day={newDate.getDate()}
              month={fromGetMonthToMonthName(newDate.getMonth())}
              year={`${newDate.getFullYear()}`}
              hour={newDate.getHours()}
              minutes={newDate.getMinutes()}
            />
          })
        }
      </div>
      {!auth?.jwtToken &&

        <div className="">
          <p className=' fw-400 my-3'>Fill the fields below to proceed with the match request confirmation</p>

          <form className={clsx("pb-5 mb-2")} onSubmit={formik.handleSubmit} autoComplete='off'>
            <div className=" d-flex flex-wrap">
              <div className={clsx("   ",
                { "col-12": mobile },
                { "col-6 pe-2": !mobile })
              }>
                {/* email */}
                <label className='text-black mt-3' htmlFor="email">Company e-mail<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
                <input
                  autoComplete="new-password"
                  placeholder='Company e-mail'
                  {...formik.getFieldProps('email')}
                  className="form-input"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={() => formik.setFieldTouched("email", true)}
                  value={formik.values.email}
                  name="email"
                />
                {formik.errors.email && formik.touched.email && <div className='text-error ms-2' id="email">{formik.errors.email}</div>}
              </div>
              <div className={clsx("   ",
                { "col-12": mobile },
                { "col-6 pe-2": !mobile })
              }>
                {/* companyName */}
                <label
                  className='text-black mt-3'
                  htmlFor="companyName">
                  Company Name<sup className='text-error' style={{ fontSize: "16px" }}>*</sup>
                </label>
                <input
                  autoComplete="new-password"
                  placeholder='Your Company Name'
                  {...formik.getFieldProps('companyName')}
                  className="form-input"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={() => formik.setFieldTouched("companyName", true)}
                  value={formik.values.companyName}
                  name="companyName"
                />
                {formik.errors.companyName && formik.touched.companyName && <div className='text-error ms-2' id="companyName">{formik.errors.companyName}</div>}
              </div>
            </div>
            <div className=" d-flex flex-row flex-wrap  ">
              <div className={clsx("   ",
                { "col-12": mobile },
                { "col-6 pe-2": !mobile })
              }>
                {/* firstName*/}
                <label className='text-black mt-3' htmlFor="firstName">First Name<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
                <input
                  autoComplete="new-password"
                  placeholder='First Name'
                  {...formik.getFieldProps('firstName')}
                  className="form-input"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={() => formik.setFieldTouched("firstName", true)}
                  value={formik.values.firstName}
                  name="firstName"
                />
                {formik.errors.firstName && formik.touched.firstName && <div className='text-error ms-2' id="firstName">{formik.errors.firstName}</div>}

              </div>
              <div className={clsx("   ",
                { "col-12": mobile },
                { "col-6 pe-2": !mobile })
              }>
                {/* lastName */}
                <label className='text-black mt-3' htmlFor="lastName">Last Name<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
                <input
                  autoComplete="new-password"
                  placeholder='Last Name'
                  {...formik.getFieldProps('lastName')}
                  className="form-input"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={() => formik.setFieldTouched("lastName", true)}
                  value={formik.values.lastName}
                  name="lastName"
                />
                {formik.errors.lastName && formik.touched.lastName && <div className='text-error ms-2' id="lastName">{formik.errors.lastName}</div>}

              </div>
            </div>
            <div className=" d-flex ">
              <div className={clsx("   ",
                { "col-12": mobile },
                { "col-6 pe-2": !mobile })
              }>
                {/* city */}
                <label
                  className='text-black mt-3'
                  htmlFor="city">City<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
                <Select
                  {...formik.getFieldProps('city')}
                  options={cities ? cities : []}
                  onChange={option => formik.setFieldValue('city', option)}
                  onBlur={() => formik.setFieldTouched("city", true)}
                  placeholder='Select your city'
                  captureMenuScroll={true}
                  name={'city'}
                  className='w-100'
                  onInputChange={(input: string) => setCity(input as string)}
                  styles={customStyles}
                  isSearchable
                  value={!!formik.values.city.value ? formik.values.city : null}
                />
                {formik.errors.city && formik.touched.city && <div className='text-error' id="companyName">{formik.errors.city.value}</div>}
              </div>
            </div>

          </form>
        </div>
      }
      <div className='d-flex align-items-baseline'>
        <span className={clsx(' fw-400  px-3', { "text-center": mobile })}>A kind reminder: by submitting your match request, you confirm your interest in evaluating this company to address the innovation needs of your organization.<sup className='text-error' >*</sup></span>
      </div>
      <div className={clsx("d-flex pt-4  w-100 ",
        { "justify-content-end flex-row": !tablet },
        { "justify-content-center align-items-center flex-column-reverse mb-5": tablet })}>
        <Button primary text={"CHANGE DATES"} background={"transparent"}
          color={"black"} borderColor={"var(--black)"}
          className={clsx("",
            { "me-4": !mobile },
            { "mt-2": mobile })}
          onClick={() => change()} />
        <Button primary text={"CONFIRM"} background={"var(--primary)"} className={"pt-3"}
          disabled={!auth?.jwtToken ? !activeConfirm : false}
          color={"white"} borderColor={"var(--primary)"}
          onClick={() => confirm()} />
      </div>
    </div>
  )

}


